module.exports = __webpack_public_path__ + "static/media/pirate.1d0c42e8.png";